import { createApp } from 'vue';

import TDesign from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';

import { store } from './store';
import router from './router';
import '@/style/index.less';
import './permission';
import App from './App.vue';

import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import { IMAGE_PREVIEW_OPTIONS } from '@/constants';

const app = createApp(App);

app.use(TDesign);
app.use(store);
app.use(router);
app.use(VueViewer, {
  defaultOptions: IMAGE_PREVIEW_OPTIONS,
});

app.mount('#app');
